<template>
  <jade-box
    class="flex-1"
    :title="$t('canceled.title')"
    hasPadding
  >
    <template>
      <div class="flex flex-col gap-2">
        <jade-text variant="heading-small">R$ {{ data.value }}</jade-text>
        <div>
          <jade-text>{{ computedText.label }}</jade-text>
          <jade-text>{{ computedText.percentage }}</jade-text>
        </div>
      </div>
    </template>
  </jade-box>
</template>

<script>
import TransactionStatusManager from './transaction-status.manager'
import { JadeBox, JadeText } from '@jade'

export default {
  name: 'TransactionStatusCanceled',

  components: {
    JadeBox,
    JadeText
  },

  props: {
    data: Object
  },

  computed: {
    computedText () {
      const label = this.$tc('canceled.sales', this.data.quantity)
      return TransactionStatusManager.getFormatedLabelAndPercentage(
        this.data,
        label
      )
    }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "canceled": {
        "title": "Cancelado",
        "description": "Cobranças que foram autorizadas e depois canceladas.",
        "sales": "cobrança | cobrança | cobranças"
      }
    },
    "en-US": {
      "canceled": {
        "title": "Canceled",
        "description": "Charges that have been authorized/captured and then canceled.",
        "sales": "charge | charge | charges"
      }
    }
  }
  </i18n>
